import { isObject } from "@posthog/core";
const DEFAULT_THRESHOLD_PX = 30;
const DEFAULT_TIMEOUT_MS = 1000;
const DEFAULT_CLICK_COUNT = 3;
class RageClick {
    constructor(rageclickConfig){
        this.disabled = false === rageclickConfig;
        const conf = isObject(rageclickConfig) ? rageclickConfig : {};
        this.thresholdPx = conf.threshold_px || DEFAULT_THRESHOLD_PX;
        this.timeoutMs = conf.timeout_ms || DEFAULT_TIMEOUT_MS;
        this.clickCount = conf.click_count || DEFAULT_CLICK_COUNT;
        this.clicks = [];
    }
    isRageClick(x, y, timestamp) {
        if (this.disabled) return false;
        const lastClick = this.clicks[this.clicks.length - 1];
        if (lastClick && Math.abs(x - lastClick.x) + Math.abs(y - lastClick.y) < this.thresholdPx && timestamp - lastClick.timestamp < this.timeoutMs) {
            this.clicks.push({
                x,
                y,
                timestamp
            });
            if (this.clicks.length === this.clickCount) return true;
        } else this.clicks = [
            {
                x,
                y,
                timestamp
            }
        ];
        return false;
    }
}
export default RageClick;
